define 'controller/SearchSuggestionsController', ['jquery', 'lib/easy-autocomplete', 'custom/media-query'], ($, easyAutocomplete, mq) ->
  class SearchSuggestionsController
    
    constructor: (@$el) ->
      $el = @$el
      self = this

      @_updatePlaceholder()
      
      # Perform search suggestions
      if $el.length > 0
        options =
          url: (phrase) ->
            $el.data('url') + '?q=' + phrase + '&format=json'
          getValue: 'name'
          list:
            match:
              enabled: true
            onClickEvent: ->
              selectedItemValue = $el.getSelectedItemData().name
              $el.val(selectedItemValue)
              $el.closest('form').submit()
            onKeyEnterEvent: ->
              $el.closest('form').submit()
          requestDelay: 150
          minCharNumber: 2
        $el.easyAutocomplete(options)

      # Update placeholder on window change event
      $(window).on 'resizeDelayed', ->
        self._updatePlaceholder()

    _updatePlaceholder: ->
      if mq.up_to_M
        @$el.attr 'placeholder', @$el.attr('data-placeholder-short')
      else
        @$el.attr 'placeholder', @$el.attr('data-placeholder')
      return
